<template>
  <div class="sysSetting">
    <div>
      <nav-bar title="系统设置"></nav-bar>
      <ih-panel
        class="panel"
        v-for="(item, key) in panelList"
        @click.native="toRoute(item.text)"
        :url="item.url"
        :text="item.text"
        :key="key"
      ></ih-panel>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
import ihPanel from "@/components/ihPanel";
export default {
  name: "sysSetting",
  data() {
    return {
      panelList: [
        {
          url: require("@/assets/icon/icon_9.png"),
          text: "注销账户"
        },
        {
          url: require("@/assets/icon/icon_10.png"),
          text: "第三方账户绑定"
        },
        {
          url: require("@/assets/icon/icon_7.png"),
          text: "导航设置"
        },
        {
          url: require("@/assets/icon/icon_8.png"),
          text: "消息通知"
        }
      ]
    };
  },
  components: {
    NavBar,
    ihPanel
  },
  methods: {
    toRoute(url) {
      console.log(url);
    }
  }
};
</script>
<style scoped lang="less">
.sysSetting {
  background: rgba(247, 247, 247, 1);
  height: 100%;
  .panel {
    width: 375px;
    height: 54px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 12px;
  }
}
</style>
